import { map, slice, merge, findIndex, sortBy, prop, reverse, path, sortWith, ascend } from 'ramda';
import { API_CALL_SUCCESS, UPDATE_SET_EDIT_MODE } from '../constants/actionTypes';
import {
    UPDATES_LIST,
    POST_HORSE_UPDATE_ON_SALE,
} from '../constants/apiConstants';

const initialState = [];

const apiUpdatesReducer = (state, action) => {
    const {
        endpoint,
    } = action;

    switch (endpoint) {
    case UPDATES_LIST:
        return map((update) => {
            return ({
                ...update,
                is_editing: false,
            });
        }, action.response);
    case POST_HORSE_UPDATE_ON_SALE:
        return state;
    default:
        return state;
    }
};

const updatesReducer = (state = initialState, action) => {
    const {
        type,
    } = action;

    switch (type) {
    case API_CALL_SUCCESS:
        return apiUpdatesReducer(state, action);
    case UPDATE_SET_EDIT_MODE:
        const updateIndex = findIndex(update => update.horse.hip === action.update.horse.hip)(state);
        return [
            ...map(a => merge(a, { is_editing: false }))(slice(0, updateIndex, state)),
            merge(state[updateIndex], {
                is_editing: action.is_editing,
            }),
            ...map(a => merge(a, { is_editing: false }))(slice(updateIndex + 1, state.length, state)),
        ];
    default:
        return state;
    }
};

export const selectUpdates = ({ updates, sort }) => {
    if (sort.tab === 'updates' && sort.column === 'horse.hip') {
        const sortColumnArray = sort.column.split('.');
        const sortColumn = sortBy(path([sortColumnArray[0], sortColumnArray[1]]));
        return sort.direction === 'desc' ? reverse(sortColumn(updates)) : sortColumn(updates);
    } else if (sort.tab === 'updates' && sort.column === 'last_updated') {
        const updateSort = sortWith([
            ascend(prop(sort.column)),
            ascend(prop(path(['horse', 'hip'])))
        ]);
        return sort.direction === 'desc' ? reverse(updateSort(updates)) : updateSort(updates);
    }
    return updates;
};

export default updatesReducer;
